import React from "react";
import { Constants } from "@eagerdog/constants";
import { ICourseWaitlist } from "@eagerdog/interfaces";
import { AxiosError } from "axios";
import type { CustomCellRendererProps } from "ag-grid-react";

import ContextMenu from "src/components/ContextMenu/ContextMenu";
import { toast } from "src/components/Toast/ToastManager";
import { apiService } from "src/services/api.service";

import styles from "./CourseWaitlistTab.module.scss";

interface IProps extends CustomCellRendererProps {
  courseId: string;
  onChanged(): void;
}

export const CourseWaitlistActions = (props: IProps) => {
  const entry = props.data?.entry as ICourseWaitlist | undefined;
  if (!entry) return null;

  const canApprove = entry.status === Constants.waitlist_status.waitlist && !!props.data?.canApprove;
  const canDecline = entry.status === Constants.waitlist_status.waitlist
    || entry.status === Constants.waitlist_status.awaiting_payment;

  const act = (kind: "approve" | "decline") => {
    const request = kind === "approve"
      ? apiService.approveCourseWaitlist(props.courseId, entry._id)
      : apiService.declineCourseWaitlist(props.courseId, entry._id);
    request.then(() => {
      toast.show({
        title: "Waitlist",
        content: kind === "approve" ? "The entry was approved." : "The entry was declined.",
        duration: 5000,
        type: "success",
      });
      props.onChanged();
    }).catch((error: AxiosError) => {
      toast.show({
        title: "Waitlist",
        content: (error.response?.data as { message?: string })?.message || "The waitlist could not be updated.",
        duration: 8000,
        errorDetails: error,
        type: "fail",
      });
    });
  };

  const options = [
    ...(canApprove ? [{ label: "Approve", onClick: () => act("approve") }] : []),
    ...(canDecline ? [{ label: "Decline", onClick: () => act("decline") }] : []),
  ];

  if (!options.length) return null;

  return (
    <div className={styles.ActionRenderer}>
      <ContextMenu options={options} />
    </div>
  );
};
